import axios from 'axios';
import { API_CONFIG } from '../../config/api.config';

/**
 * Dedicated axios instance for the standalone Dynamic Admin Module.
 * Uses its own token (rrms_admin_token) and its own base path, fully decoupled
 * from the CMS-based RRMS app's axios/auth.
 */
const adminAxios = axios.create({
  baseURL: `${API_CONFIG.BASE_URL}/api/rrms/admin`,
  timeout: API_CONFIG.TIMEOUT,
  headers: { 'Content-Type': 'application/json' },
});

export const ADMIN_TOKEN_KEY = 'rrms_admin_token';

// Match the router basename (BrowserRouter uses process.env.PUBLIC_URL) so the
// 401 redirect works whether the app is served at '/' or under a base like '/rrms'.
const LOGIN_PATH = `${process.env.PUBLIC_URL || ''}/admin/login`;

adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) (config.headers as any).token = token;
  return config;
});

adminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      if (!window.location.pathname.startsWith(LOGIN_PATH)) {
        window.location.href = LOGIN_PATH;
      }
    }
    return Promise.reject(error);
  }
);

export default adminAxios;
